'use client'

import { Button } from '@/components/v2/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from '@/components/v2/ui/dialog'
import Icon from '@/components/v2/ui/icon'
import { useTexts } from '@/contexts/LanguageContext'
import RequestAccessForm from './RequestAccessForm'
import { useRequestAccessForm } from './useRequestAccessForm'

interface IRequestAccessDialogProps {
  options: string[]
  defaultSelected?: string[]
  children: React.ReactNode
}

function RequestSent() {
  const { REQUEST_ACCESS } = useTexts().PUBLIC_TRUST_CENTER
  return (
    <div className="flex flex-col items-center gap-2.5 px-8 py-11 text-center">
      <span className="flex size-11 items-center justify-center rounded-full border border-trust-center-border-strong bg-trust-center-subtle text-trust-center-accent">
        <Icon icon="check" className="size-5" />
      </span>
      <span className="text-base font-semibold">{REQUEST_ACCESS.SENT_TITLE}</span>
      <span className="max-w-xs text-sm text-pretty text-trust-center-muted">{REQUEST_ACCESS.SENT_DESCRIPTION}</span>
      <DialogClose asChild>
        <Button className="mt-2 bg-trust-center-accent text-white hover:bg-trust-center">{REQUEST_ACCESS.CLOSE}</Button>
      </DialogClose>
    </div>
  )
}

export default function RequestAccessDialog({ options, defaultSelected = [], children }: IRequestAccessDialogProps) {
  const { REQUEST_ACCESS } = useTexts().PUBLIC_TRUST_CENTER
  const state = useRequestAccessForm(defaultSelected)
  return (
    <Dialog onOpenChange={(isOpen) => isOpen || state.reset()}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="gap-0 p-0 text-trust-center sm:max-w-lg">
        <div className="flex items-start gap-3 border-b border-trust-center-border px-5 py-4.5">
          <span className="flex size-8 shrink-0 items-center justify-center rounded-md bg-trust-center-subtle">
            <Icon icon="lock" className="size-4" />
          </span>
          <div className="flex flex-col gap-0.5">
            <DialogTitle className="text-base font-semibold">{REQUEST_ACCESS.TITLE}</DialogTitle>
            <DialogDescription className="text-xs text-trust-center-muted">
              {REQUEST_ACCESS.DESCRIPTION}
            </DialogDescription>
          </div>
        </div>
        {state.isSent ? <RequestSent /> : <RequestAccessForm options={options} state={state} />}
      </DialogContent>
    </Dialog>
  )
}
